import { application } from '~/controllers/application'
import { registerControllers } from 'stimulus-vite-helpers'

const controllers = import.meta.glob(['~/controllers/lazy_load_video_controller.js'], { eager: true })

registerControllers(application, controllers)
